module.exports = __webpack_public_path__ + "static/media/infoJumbo2.f263c632.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/fetzer/images/infoJumbo2.jpg
// module id = 491
// module chunks = 0